import client from './http';

const config = {
  headers: {
    'Content-Type': 'application/json',
  },
};

const sendComment = (id, data) => {
  data.fullResponse = true; // eslint-disable-line no-param-reassign
  return client.post(`pos/${id}/comments/`, data, config);
};

export default sendComment;



// WEBPACK FOOTER //
// ./src/services/comments.js